<template>
  <div class="sgc-chips-wrap">
    <div class="sgc-chips-ctr">
      <v-chip
        v-for="(item, index) in modelValue"
        :key="index"
        class="autocmp-chip"
        size="small"
        :disabled="disabled"
        closable
        :text="item"
        @click:close="removeOption(index)"
      />
    </div>
    <v-autocomplete
      ref="list"
      v-model="tmp"
      clearable
      hideDetails
      hideNoData
      autofocus
      variant="outlined"
      density="compact"
      itemTitle="text"
      bgColor="#ffffff"
      :disabled="disabled"
      persistentPlaceholder
      :items="options"
      :searchInput="tmp"
      class="sgc-autocomplete-location"
      :placeholder="title"
      @update:modelValue="addOption"
    />
  </div>
</template>

<script>
export default {
  name: "RfAutoCompletionWithChips",
  props: ["options", "title", "help", "modelValue", "disabled"],
  data() {
    return {
      tmp: "",
    };
  },
  methods: {
    addOption(option) {
      if (option) {
        this.$emit("update:modelValue", Array.from(new Set([...this.modelValue, option])));
      }
      this.tmp = "";
    },
    removeOption(index) {
      this.$emit(
        "update:modelValue",
        this.modelValue.filter((_, i) => i !== index),
      );
    },
  },
};
</script>
